(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["gamble-gallery"] && !Shopify.designMode) return;
  try {
    (() => {
  const dialog = document.getElementById('GambleGallery');
  if (!dialog || typeof dialog.showModal !== 'function') return;
  const stage = dialog.querySelector('.gc-gallery-image');
  const caption = dialog.querySelector('.gc-gallery-caption');
  const count = dialog.querySelector('.gc-gallery-count');
  const previous = dialog.querySelector('[data-gc-prev]');
  const next = dialog.querySelector('[data-gc-next]');
  let frames = [];
  let current = 0;
  let opener = null;
  function show(index) {
    current = (index + frames.length) % frames.length;
    const frame = frames[current];
    const photo = new Image();
    photo.alt = frame.dataset.gcCaption || frame.querySelector('img')?.alt || '';
    const thumbnail = frame.querySelector('img') || frame.closest('.gc-size-guide')?.querySelector('img');
    photo.src = thumbnail?.currentSrc || frame.href;
    stage.replaceChildren(photo);
    if (photo.src !== frame.href) {
      const original = new Image();
      original.onload = () => { if (photo.isConnected) photo.src = frame.href; };
      original.src = frame.href;
    }
    caption.textContent = photo.alt;
    count.textContent = `${current + 1} / ${frames.length}`;
    previous.hidden = next.hidden = frames.length < 2;
  }
  document.addEventListener('click', event => {
    const frame = event.target.closest('a[data-gc-gallery]');
    if (!frame || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
    event.preventDefault();
    opener = frame;
    frames = Array.from(document.querySelectorAll('a[data-gc-gallery]')).filter(item => item.dataset.gcGallery === frame.dataset.gcGallery);
    show(frames.indexOf(frame));
    dialog.showModal();
    document.documentElement.classList.add('gc-gallery-is-open');
  });
  dialog.querySelector('.gc-gallery-close').addEventListener('click', () => dialog.close());
  previous.addEventListener('click', () => show(current - 1));
  next.addEventListener('click', () => show(current + 1));
  dialog.addEventListener('keydown', event => {
    if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
      event.preventDefault();
      show(current + (event.key === 'ArrowRight' ? 1 : -1));
    }
  });
  dialog.addEventListener('close', () => {
    document.documentElement.classList.remove('gc-gallery-is-open');
    stage.replaceChildren();
    if (opener?.isConnected) opener.focus({preventScroll: true});
  });
})();
  } catch(e) { console.error(e); }
})();

})();
